import React from "react";

import {ModeltypeBasicDto} from "../../../services/Client";

import {DerivateUtils} from "../../../components/Table/components/derivate/DerivateUtils";
import SelectField, {OptionValue} from "../../../components/SelectField";
import Button from "../../../components/Button";

interface IDerivatesSelectionStepProps {

    /** Derivates available for selection */
    allDerivates: ModeltypeBasicDto[];

    /** Selected derivates */
    selectedDerivates: ModeltypeBasicDto[];

    /** Translation */
    t: reactI18Next.TranslationFunction;

    /** Action on selection change */
    onChange: (source: ModeltypeBasicDto[]) => void;

    /** Action for moving to next step */
    onStepForward: () => void;

    userLanguage: string;
}

export const DerivatesSelectionStep = (props: IDerivatesSelectionStepProps) => {

    return (
        <>
            <div className={'margin-top--10px'}>
                <SelectField
                    placeholder={props.t("UPDATE_DRF_ASGN:SELECT_DERIVATES")}
                    clearable={true}
                    searchable={true}
                    multi={true}
                    value={props.selectedDerivates}
                    rendererKey={(value: OptionValue) => DerivateUtils.renderKeyDerivate(value as ModeltypeBasicDto, props.userLanguage)}
                    dataSource={props.allDerivates}
                    onChange={(values?: any[]) => props.onChange(values ? values.map((v) => v.selectedValue as ModeltypeBasicDto) : [])}
                />
            </div>

            <div style={{marginTop: '20px', textAlign: 'right'}}>
                <Button
                    icon={'arrow right'}
                    disabled={props.selectedDerivates.length === 0}
                    onClick={props.onStepForward}
                />
            </div>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/views/OptionsView/updateDraftAssignments/DerivatesSelectionStep.tsx